// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Tu-z","tooltipWrapper":"Uu-z","icon":"Vu-z","tooltip":"Wu-z","content":"Xu-z"};